import { PlayerActionType } from './actions';
import type { TDiscardReaction } from './ruleset';
import type { TSeat } from './types';

const seatDistance = (originSeat: TSeat, candidateSeat: TSeat): number =>
  (candidateSeat - originSeat + 4) % 4;

const meldReactionPriority = (reactions: readonly TDiscardReaction[]): number => {
  if (reactions.some((reaction) => reaction.type === PlayerActionType.Pong)) return 0;
  if (reactions.some((reaction) => reaction.type === PlayerActionType.KongExposed)) return 1;
  if (reactions.some((reaction) => reaction.type === PlayerActionType.Chi)) return 2;
  return Number.POSITIVE_INFINITY;
};

export const orderedReactionSeats = (
  originSeat: TSeat,
  candidates: readonly TSeat[]
): readonly TSeat[] =>
  [...new Set(candidates)]
    .filter((seat) => seat !== originSeat)
    .sort((left, right) => seatDistance(originSeat, left) - seatDistance(originSeat, right));

/** 吃碰槓候選依「碰 > 槓 > 吃」排序；同優先序再由出牌者下家方向決定順位。 */
export const orderedMeldReactionSeats = (
  originSeat: TSeat,
  candidates: ReadonlyMap<TSeat, { readonly reactions: readonly TDiscardReaction[] }>
): readonly TSeat[] =>
  [...candidates.entries()]
    .filter(([seat, legal]) => seat !== originSeat && legal.reactions.length > 0)
    .sort(([leftSeat, leftLegal], [rightSeat, rightLegal]) => {
      const priorityDifference =
        meldReactionPriority(leftLegal.reactions) - meldReactionPriority(rightLegal.reactions);
      if (priorityDifference !== 0) return priorityDifference;
      return seatDistance(originSeat, leftSeat) - seatDistance(originSeat, rightSeat);
    })
    .map(([seat]) => seat);
